import { Controller } from "@hotwired/stimulus"

// Полноэкранный просмотр фото заказа.
// Клик по миниатюре открывает оверлей; при >1 фото — стрелки ‹ ›
// (листание зациклено). Закрытие: ESC, крестик, клик по фону.
// Навигация с клавиатуры: ← →.
export default class extends Controller {
  static targets = ["thumb", "overlay", "image", "counter"]

  connect() {
    this.urls = this.thumbTargets.map((t) => t.dataset.fullUrl)
    this.index = 0
    this._onKey = this.onKey.bind(this)
  }

  disconnect() {
    this.unlockScroll()
    document.removeEventListener("keydown", this._onKey)
  }

  open(event) {
    this.index = parseInt(event.currentTarget.dataset.index, 10) || 0
    this.show()
    this.overlayTarget.classList.remove("d-none")
    this.lockScroll()
    document.addEventListener("keydown", this._onKey)
  }

  close(event) {
    if (event) event.preventDefault()
    this.overlayTarget.classList.add("d-none")
    this.unlockScroll()
    document.removeEventListener("keydown", this._onKey)
  }

  // Закрытие по клику на фон (но не по самому изображению/кнопкам).
  backdrop(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  next(event) {
    if (event) event.preventDefault()
    this.index = (this.index + 1) % this.urls.length
    this.show()
  }

  prev(event) {
    if (event) event.preventDefault()
    this.index = (this.index - 1 + this.urls.length) % this.urls.length
    this.show()
  }

  show() {
    this.imageTarget.src = this.urls[this.index]
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.index + 1} / ${this.urls.length}`
    }
  }

  onKey(event) {
    switch (event.key) {
      case "Escape":
        this.close()
        break
      case "ArrowRight":
        if (this.urls.length > 1) this.next()
        break
      case "ArrowLeft":
        if (this.urls.length > 1) this.prev()
        break
    }
  }

  lockScroll() {
    document.body.classList.add("lightbox-open")
  }

  unlockScroll() {
    document.body.classList.remove("lightbox-open")
  }
}
